'use strict';

var React = require('react'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    UserStore = require('../stores/UserStore'),
    ZineStore = require('../stores/ZineStore'),
    StampStore = require('../stores/StampStore'),
    UserLatestStampStore = require('../stores/UserLatestStampStore'),
    UserLikedStampStore = require('../stores/UserLikedStampStore'),
    StampActionCreators = require('../actions/StampActionCreators'),
    Group = require('../organisms/Group'),
    Loader = require('../atoms/Loader'),
    SidebarBody = require('../organisms/SidebarBody'),
    EmptyState = require('../molecules/EmptyState'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    Button = require('../atoms/Button'),
    { transitionTo } = require('../router'),
    { PropTypes } = React;

var AddStampsToZine = React.createClass({
  mixins: [
    createStoreMixin(UserLatestStampStore, UserLikedStampStore, StampStore, ZineStore),
    PureRenderMixin
  ],

  propTypes: {
    zineSlug: PropTypes.string.isRequired
  },

  getStateFromStores(props) {
    var zine = ZineStore.get(props.zineSlug),
        me = UserStore.getMe(),
        isMyZine = UserStore.isMe(zine.curator),
        latestStamps = UserLatestStampStore.getStamps(me.id),
        isReady = UserLatestStampStore.getPageCount(me.id) > 0,
        likedStamps = [];

    if (isMyZine) {
      likedStamps = UserLikedStampStore.getStamps(me.id);
      isReady = isReady && UserLikedStampStore.getPageCount(me.id) > 0;
    }

    return {
      zine: zine,
      isReady: isReady,
      isMyZine: isMyZine,
      latestStamps: latestStamps,
      likedStamps: likedStamps
    };
  },

  componentDidMount() {
    var me = UserStore.getMe();
    StampActionCreators.requestUserLatestPage(me.id, true);

    if (this.state.isMyZine) {
      StampActionCreators.requestUserLikedPage(me.id, true);
    }
  },

  render() {
    var { isMyZine } = this.state,
        title,
        subtitle;

    if (isMyZine) {
      title = 'Add Stamps';
      subtitle = 'Pick relevant stamps for this collection.';
    } else {
      title = 'Submit Your Stamps';
      subtitle = <span>We will notify you once the curator<br />has accepted or declined your submissions.</span>;
    }

    return (
      <SidebarBody title={title}
                   subtitle={subtitle}>
        {this.renderGroups()}
      </SidebarBody>
    );
  },

  renderGroups() {
    if (!this.state.isReady) {
      return <Loader absoluteCenter />;
    }

    var userId = UserStore.getMe().id;

    var {
      zine,
      latestStamps,
      likedStamps,
      isMyZine
    } = this.state;

    var hasLatest = latestStamps.length > 0,
        hasLiked = likedStamps.length > 0;

    if (!hasLatest && !hasLiked) {
      var label = isMyZine ?
        'You do not have any published or liked stamps.' :
        'You do not have any published stamps.';

      return (
        <EmptyState label={label}
                    absoluteCenter>
          <Button onClick={this.handleCreateStampClick}>
            Create a Stamp
          </Button>
        </EmptyState>
      );
    }

    return {
      latestStamps: hasLatest && (
        <Group type='stamps'
               title='Published Stamps'
               items={latestStamps}
               context='sidebar'
               mode='grid'
               columns={2}
               itemProps={{
                 size: 'small',
                 showSubmit: true,
                 targetZine: zine
               }}
               isExpectingPage={UserLatestStampStore.isExpectingPage(userId)}
               isLastPage={UserLatestStampStore.isLastPage(userId)}
               isInvalidated={UserLatestStampStore.isInvalidated(userId)}
               loadNextPage={this.requestNextLatestPage} />
      ),

      likedStamps: hasLiked && (
        <Group type='stamps'
               title='Liked Stamps'
               items={likedStamps}
               context='sidebar'
               mode='grid'
               columns={2}
               itemProps={{
                 size: 'small',
                 showSubmit: true,
                 targetZine: zine
               }}
               isExpectingPage={UserLikedStampStore.isExpectingPage(userId)}
               isLastPage={UserLikedStampStore.isLastPage(userId)}
               isInvalidated={UserLikedStampStore.isInvalidated(userId)}
               loadNextPage={this.requestNextLikedPage} />
      ),
    };
  },

  handleCreateStampClick() {
    transitionTo('draftCompose', { stampSegment: 'new' });
  },

  requestNextLatestPage() {
    var userId = UserStore.getMe().id;
    StampActionCreators.requestUserLatestPage(userId);
  },

  requestNextLikedPage() {
    var userId = UserStore.getMe().id;
    StampActionCreators.requestUserLikedPage(userId);
  }
});

module.exports = AddStampsToZine;



/** WEBPACK FOOTER **
 ** ./sidebar/AddStampsToZine.jsx
 **/